import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '@uw/core/base-control';
import { takeUntil } from 'rxjs';
import { CheckboxOption } from './checkbox-option.model';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'uw-checkbox',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <ng-container [formGroup]="form">
      <mat-checkbox class="uw-checkbox" formControlName="checked">
        {{ "common." + form.value.displayName | translate }}
      </mat-checkbox>
    </ng-container>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, MatCheckbox, TranslateModule]
})
export class CheckboxComponent extends BaseControl {
  readonly form = new UntypedFormGroup({
    value: new UntypedFormControl(null, []),
    displayName: new UntypedFormControl(null, []),
    checked: new UntypedFormControl(null, []),
  });

  writeValue(obj: CheckboxOption): void {
    this.form.patchValue(obj, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.form.valueChanges
      .pipe(takeUntil(this._destroyed$))
      .subscribe(fn);
  }
}
